import { Checkbox, FormControlLabel, FormGroup } from '@mui/material';
import { LIST_PHASES } from '../../../shared/AppConstants';

export function PhasesTags({ setSelectedPhases, selectedPhases, namePrefix }) {
  const handleCheckboxChange = (event) => {
    const { value, checked } = event.target;

    setSelectedPhases((prevSelectedPhases) => {
      return checked
        ? [...prevSelectedPhases, value]
        : prevSelectedPhases.filter((phase) => phase !== value);
    });
  };

  return (
    <FormGroup>
      {LIST_PHASES.map((phase, index) => (
        <FormControlLabel
          key={index}
          style={{ marginLeft: '0' }}
          control={
            <Checkbox
              id={`${namePrefix}-${index + 1}`}
              value={phase}
              checked={selectedPhases.includes(phase)}
              onChange={handleCheckboxChange}
            />
          }
          label={phase}
        />
      ))}
    </FormGroup>
  );
}
